import { QueryClient } from '@tanstack/react-query';
import { httpBatchLink } from '@trpc/client';
import { createTRPCReact } from '@trpc/react-query';
import { createTRPCContext } from '@trpc/tanstack-react-query';
import type { AppRouter } from 'api';
import { env } from 'config/env';

import { authClient } from 'integration/AuthApi';

const url = `${env.trpcURL}/trpc`;

export const queryClient = new QueryClient();

const headers = async () => {
  const session = await authClient.getSession();

  if (!session) {
    return {};
  }

  const token = await session.getIdToken();

  return {
    Authorization: `Bearer ${token}`,
  };
};

export const trpc = createTRPCReact<AppRouter>();

export const trpcClient = trpc.createClient({
  links: [
    httpBatchLink({
      url,
      headers,
    }),
  ],
});

// // For backwards compatibility
// export const TRPCProvider = trpc.Provider;
// export const useTRPC = trpc.useContext;
// export const useTRPCClient = () => trpcClient;

export const { TRPCProvider, useTRPC, useTRPCClient } =
  createTRPCContext<AppRouter>();
